<template lang="pug">
.v-favorite.favorite(v-if="data" )
	.container
		.favorite__header
			h1.favorite__title {{ favoriteTitle }}
			button.favorite__button(v-if="data.button && !favoriteEmpty" @click="cleanFavorite")
				v-svg-icon.favorite__button-icon(:icon="data.button?.icon")
				span.favorite__button-text {{ data.button?.text }}
		template(v-if="favoriteEmpty" )
			span.favorite__main-template {{ data.variables.empty }}
		template(v-else-if="state.view === 'list'")
			.catalog__top-nav.flc(v-if="data.sort || data.view && data.view.options && data.view.options.length")
				.catalog__top-nav-grid
					.catalog__top-nav-cell--left
						.catalog__top-nav-cell.catalog__top-nav-cell--total(v-if="favoriteCount")
							| {{ `${favoriteCount} ${data.variables.object}` }}
						.catalog__top-nav-cell.catalog__top-nav-cell--total(v-else)
							| {{ `0 ${data.variables.object}` }}
						.catalog__top-nav-cell.catalog__top-nav-cell--select(v-if="data.sort")
							v-field(:field="{type: 'select', options: data.sort.options}"
								v-model="state.sort"
								@update:model-value="sortChanged")
					.catalog__top-nav-cell--right
						//.catalog__top-nav-cell.catalog__top-nav-cell--view(v-if="data.view")
						//	v-field(:field="{type: 'view-picker', options: data.view.options}"
						//		v-model="state.view")
			.favorite__tabs.tabs-nav(v-for="(filter, index) in data.filters" :key="index")
				v-field(:field="filter" v-model="filter.value" @update:model-value="filterChange(filter, $event)")
			.favorite__main
				.favorite__main-list(v-if="data.items" )
					.favorite__main-card(v-for="(card, index) in data.items" :key="index")
						v-product(template="list" :product="card")
			.favorite__nav.flc
				v-page-nav(:page="data.page" :variables="data.variables" :limits="data.limits" @navigate="navigate")
		.catalog__map-filter(v-else-if="state.view === 'map'")
			.map-filter__nav
				.map-filter__view(v-if="data.view")
					v-field(:field="{type: 'view-picker', options: data.view.options}"
						v-model="state.view")
			v-map-google.map-filter__map(
				:type="data.type"
				:initParams="data.map"
				:items="data.itemsOnMap"
				:variables="data.variables"
				@drawing-area="drawingArea")
		.favorite__help-block.help-block(v-if="data.help" )
				.help-block__wrap
					v-svg-icon.help-block__icon(v-if="data.help.icon" :icon="data.help.icon")
					.help-block__inner
						.help-block__title(v-if="data.help.title" ) {{ data.help.title }}
						.help-block__text(v-if="data.help.text" v-html="data.help.text" )
				a.help-block__button(v-if="data.help.link" :href="data.help.link?.href || '#'" :class="data.help.link?.className") {{ data.help.link?.text }}
</template>


<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';
import { mapActions } from 'vuex';

export default {

	mixins: [
		sourceMixin,
		formattingMixin
	],

	data() {
		return {
			data: null,
			favoriteCount: null,
			state: {
				page: null,
				sort: null,
				view: null,
				filter: null
			},
		};
	},

	methods: {
		...mapActions({
			removeAll: 'favorite/removeAll',
		}),

		dataSet(data) {
			this.data = data;
			this.favoriteCount = this.data.favoriteCount
			this.state.sort = this.data.sort ? this.data.sort.value : null;
			this.state.page = this.data.page;
			this.state.view = this.state.view || this.data.view && this.data.view.value || 'list';
		},

		requestDataLoad(dataSetOptions) {
			this.dataLoad({
				url: this.data.remote,
				delay: true,
				data: {
					page: this.state.page,
					sort: this.state.sort,
					filter: this.state.filter
				}
			}, dataSetOptions);
		},

		navigate(page) {
			this.state.page.offset = page.offset;
			this.state.page.limit = page.limit;
			this.requestDataLoad({append: page.append});
		},

		sortChanged() {
			this.state.page.offset = 0;
			this.requestDataLoad();
		},

		filterChange(filter, value) {
			this.state.filter = {...this.state.filter, [filter.id]: value}
			this.state.page.offset = 0;
			this.requestDataLoad();
		},

		cleanFavorite() {
			if (this.favorite && this.favorite.items) {
				this.removeAll()
			}
		},

		drawingArea(path) {
			this.dataLoad({
				url: this.catalog.remote,
				delay: true,
				data: {
					filter: this.state.filter,
					mapFilter: path,
				}
			});
		},
	},

	computed: {
		favorite() {
			return this.$store.state.favorite;
		},

		favoriteTitle() {
			return this.$store.state.favorite.title;
		},

		favoriteEmpty() {
			return this.$store.getters['favorite/favoriteEmpty'];
		},

		// favoriteCount() {
		// 	return this.$store.getters['favorite/favoriteCount'];
		// }
	}
};
</script>